import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ServicesPage from '../pages/services/page';
import PartiesPage from '../pages/parties/page';
import AboutPage from '../pages/about/page';
import LocationPage from '../pages/location/page';
import FAQsPage from '../pages/faqs/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/art-classes', element: <ServicesPage /> },
  { path: '/parties-events', element: <PartiesPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/location', element: <LocationPage /> },
  { path: '/faqs', element: <FAQsPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
